import { useEffect, useRef, useState } from 'react';

// An awaited save may close only the exact editor/input that submitted it.
export function useReviewDraft(initial) {
  const [value, update] = useState(initial);
  const revision = useRef(0);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    const token = revision;
    return () => { mounted.current = false; token.current++; };
  }, []);
  const set = next => { revision.current++; update(next); };
  const capture = () => {
    const expected = revision.current;
    return () => mounted.current && revision.current === expected;
  };
  return [value, set, capture];
}
